export default "__VITE_ASSET__DtoW34bf__"